import type { GetAssessmentResultParentAuditByIdResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetAssessmentResultParentAuditByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetAssessmentResultParentAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetAssessmentResultParentAuditByIdArgs = {
  id: string;
};

export const useGetAssessmentResultParentAuditById = createQueryHook<
  UseGetAssessmentResultParentAuditByIdArgs,
  GetAssessmentResultParentAuditByIdResponseRow[],
  GetAssessmentResultParentAuditByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getAssessmentResultParentAuditById.queryOptions({
      id,
    }),
  mapTrpcDataToGraphQL: (data) => ({
    assessment_result_parent_audit: data,
  }),
  graphqlDocument: GetAssessmentResultParentAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
